export default __webpack_public_path__ + "static/media/Global-bureau.59043a40.jpg";